"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CompletedHouses = require("./CompletedHouses");
Object.keys(_CompletedHouses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CompletedHouses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CompletedHouses[key];
    }
  });
});